import { React, useState, useRef } from "react";
// import "./PublicLimitedCompany.css";
import "./PrivateLimitedCompany.css";

import ContactPopup from "./ContactPopup";

const PublicLimitedCompany = () => {

  const [openPopup, setOpenPopup] = useState(false);
  const contactRef = useRef(null);
  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>Public Limited Company Registration</h1>

        <p className="subtitle">
          Scale Your Business & Raise Capital from the Public
        </p>

        <p className="desc">
          Build a Strong Corporate Identity with Growth Potential. We provide complete assistance in registering a Public Limited Company, helping you meet all legal requirements and prepare your business for expansion and investment opportunities.
        </p>

        <div className="badges">
          <span>✔ Ideal for Large Businesses</span>
          <span>✔ Easy Access to Capital</span>
          <span>✔ Strong Credibility</span>
          <span>✔ Expert Compliance Support</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS PUBLIC LTD */}
      <div className="section">
        <h2>What is a Public Limited Company?</h2>
        <p>
          A Public Limited Company is a corporate structure that allows businesses to raise capital from the public by issuing shares. It has a separate legal identity and is governed by the Companies Act, 2013 in India.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of Public Limited Company</h2>
        <ul>
          <li>Ability to raise funds from the public</li>
          <li>Limited liability for shareholders</li>
          <li>Enhanced credibility and trust</li>
          <li>Easy transferability of shares</li>
          <li>Perpetual succession</li>
          <li>Better growth and expansion opportunities</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our Services Include</h2>
        <ul>
          <li>Digital Signature Certificate (DSC)</li>
          <li>Director Identification Number (DIN)</li>
          <li>Name Approval (RUN)</li>
          <li>MOA & AOA Drafting</li>
          <li>Company Incorporation Filing</li>
          <li>Certificate of Incorporation</li>
          <li>PAN & TAN Application</li>
          <li>Bank Account Assistance</li>
          <li>Basic Compliance Guidance</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Directors & Shareholders:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof (Bank Statement / Utility Bill)</li>
        </ul>

        <h3>For Registered Office:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill (Electricity/Water)</li>
        </ul>
      </div>

      {/* ELIGIBILITY */}
      <div className="section">
        <h2>Eligibility Criteria</h2>
        <ul>
          <li>Minimum 3 Directors required</li>
          <li>Minimum 7 Shareholders required</li>
          <li>At least 1 Director must be an Indian resident</li>
          <li>No minimum capital requirement (as per latest norms)</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Understand business goals</li>
          <li>Document Collection – Gather required documents</li>
          <li>Name Approval – Reserve company name</li>
          <li>Filing Process – Submission with authorities</li>
          <li>Approval – Receive incorporation certificate</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>Company Registration</li>
              <li>PAN & TAN</li>
              <li>DSC for Directors</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Everything in Basic</li>
              <li>Bank Account Assistance</li>
              <li>Compliance Guidance</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Everything in Standard</li>
              <li>GST Registration</li>
              <li>Extended Compliance Support</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Experienced Corporate Experts</li>
          <li>End-to-End Service</li>
          <li>Fast & Reliable Process</li>
          <li>Transparent Pricing</li>
          <li>Dedicated Support</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Difference between Pvt Ltd & Public Ltd?</b> Public Ltd can raise funds from public.</p>
        <p><b>Is stock exchange listing mandatory?</b> No, it is optional.</p>
        <p><b>How long does registration take?</b> 7–15 working days.</p>
        <p><b>Is compliance higher?</b> Yes, compared to Pvt Ltd.</p>
      </div>

      {/* CTA */}
      <div className="cta"
        ref={contactRef}>
        <h2>Ready to Take Your Business Public?</h2>
        <p>Register your Public Limited Company with expert guidance.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default PublicLimitedCompany;